import React, { useState } from 'react';
import { Trans, useTranslator, useUrlLocalizer } from 'tradera/lang/translate';
import { useSelector } from 'react-redux';
import {
    selectIsPreferredCurrencySEK,
    selectPreferredCurrency
} from 'tradera/state/multi-currency/selectors';
import InfoIcon from '@tradera/blueprint/theme/icons2/info.svg?jsx';
import { Button } from 'tradera/components/atoms/button/button';
import { Text } from 'tradera/components/atoms/text/text';
import { ScrollableModal } from 'tradera/components/scrollable-modal/scrollable-modal';

export const CurrencyConversionInfoModal = ({
    isBin = false,
    className = ''
}) => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();
    const currency = useSelector(selectPreferredCurrency).code;
    const [visible, setVisible] = useState(false);
    const isPreferredCurrencySEK = useSelector(selectIsPreferredCurrencySEK);

    if (isPreferredCurrencySEK) {
        return null;
    }

    return (
        <div className={className}>
            <div className="d-flex mb-1">
                <InfoIcon className="icon-gray-800 icon icon-sm mr-1" />
                <Text
                    fontWeight="medium"
                    size="oslo"
                    color="gray-600"
                    className="mb-0">
                    <Trans
                        i18nKey={
                            isBin
                                ? 'checkout_bin_currency_conversion_info_Trans'
                                : 'vip_bid_currency_conversion_info_Trans'
                        }
                        components={{
                            readMoreLink: (
                                <Button
                                    theme="link"
                                    className="size-oslo"
                                    onClick={() => setVisible(true)}
                                />
                            )
                        }}
                    />
                </Text>
            </div>
            <ScrollableModal
                show={visible}
                onClose={() => setVisible(false)}
                title={t('vip_bid_currency_conversion_info_header')}>
                <Trans
                    i18nKey="vip_bid_currency_conversion_info_body_Trans"
                    values={{ currency }}
                    components={{
                        settingsLink: (
                            <a
                                href={toLocalizedUrl(
                                    '/my/settings/localization'
                                )}
                                className="link"
                                target="_blank"
                                rel="noreferrer"
                            />
                        ),
                        strong: <mark className="font-weight-bold" />
                    }}
                />
            </ScrollableModal>
        </div>
    );
};
